import { Autocomplete, TextField, Typography } from "@mui/material"
import type { FilterOption } from "./index"
import UniverseSearchOption from "./universe-search-option"
import { useState } from "react"

interface FilterAutocompleteProps {
  label: string
  options: FilterOption[]
  applyLongToShort?: boolean
  onChange: (newValue: FilterOption | null) => void
  overrideValue?: FilterOption | null
  value: FilterOption | null
  onMenuOpen?: () => void
}

export default function FilterAutocomplete({
  applyLongToShort = false,
  label,
  options,
  onChange,
  overrideValue,
  value,
  onMenuOpen,
}: FilterAutocompleteProps) {
  const [open, setOpen] = useState(false)

  function handleOpen() {
    onMenuOpen?.()
    setOpen(true)
  }

  const selectedValue = applyLongToShort ? overrideValue : value
  return (
    <Autocomplete
      size="small"
      className="autocomplete-field"
      options={options}
      disabled={applyLongToShort}
      value={selectedValue}
      onChange={(_, newValue) => onChange(newValue)}
      getOptionLabel={(option) => option.label}
      getOptionDisabled={(option) => option.disabled ?? false}
      disablePortal
      onOpen={handleOpen}
      open={open}
      onClose={() => setOpen(false)}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "flip",
              enabled: false,
            },
            {
               name: "preventOverflow",
               enabled: false,
             },
          ],
        },
      }}
      renderInput={(params) => <TextField
        {...params}
        label={label}
        slotProps={{
          inputLabel: {
            style: {
              fontSize: "1rem",
            },
          },
        }}
      />}
      renderOption={(props, option) => <UniverseSearchOption option={option} props={props} numOptions={options.length} />}
      groupBy={(option) => option.group ?? ""}
      renderGroup={(params) => (
        <li key={params.key}>
          {params.group && <Typography variant="subtitle2" className="saved-searches-header">{params.group.toUpperCase()}</Typography>}
          <ul className="saved-searches-list">{params.children}</ul>
        </li>
      )}
    />
  )
}
